import { ListParams } from "../models/listParams";
import { OrganizationFilter } from "../models/notification/organizationFilter";
import { MarkReadResponse } from "../models/notification/markRead";
import { NotificationListResponse } from "../models/notification/notification";
import { UnreadCountByCategoryResponse, UnreadCountResponse } from "../models/notification/unreadCount";
import { NotificationsWebService } from "../webservices/notifications.web.service";
import { BaseService } from "./base.service";
import { retryWithAuth } from "./utils/retryWithAuth";

export class NotificationsService extends BaseService {
  private static instance: NotificationsService;

  // Private constructor to prevent direct instantiation
  private constructor() {
    super();
  }

  public static getInstance(): NotificationsService {
    if (!NotificationsService.instance) {
      NotificationsService.instance = new NotificationsService();
    }
    return NotificationsService.instance;
  }

  private getService(): NotificationsWebService {
    return new NotificationsWebService();
  }

  public async getNotifications(params: ListParams): Promise<NotificationListResponse> {
    const service = this.getService();
    return this.getOrganisatieOrReject().then(org =>
      retryWithAuth(() => service.getNotifications(org.id, params), 2)
    );
  }

  public async getUnreadCount(): Promise<UnreadCountResponse> {
    const service = this.getService();
    return this.getOrganisatieOrReject().then(org =>
      retryWithAuth(() => service.getUnreadCount(org.id), 2)
    );
  }

  public async getUnreadCountByCategory(): Promise<UnreadCountByCategoryResponse> {
    const service = this.getService();
    return this.getOrganisatieOrReject().then(org =>
      retryWithAuth(() => service.getUnreadCountByCategory(org.id), 2)
    );
  }

  public async getOrganizationFilter(): Promise<OrganizationFilter[]> {
    const service = this.getService();
    return this.getOrganisatieOrReject().then(org =>
      retryWithAuth(() => service.getOrganizationFilter(org.id), 2)
    );
  }

  public async markRead(notificationIds: string[], isRead: boolean): Promise<MarkReadResponse> {
    const service = this.getService();
    return this.getOrganisatieOrReject().then(org =>
      // Niet redirecten bij 403: de component toont een snackbar-foutmelding.
      retryWithAuth(() => service.markRead(notificationIds, isRead, org.id), 2, { redirectOnForbidden: false })
    );
  }
}

export const notificationsService = NotificationsService.getInstance();
